import CampainPlugElementDetails from '@components/plugs/modals/Details/detailObjects/CampainPlugElementDetails';
import React, { FunctionComponent } from 'react';
type Props = { _type };

const getDetailContent: FunctionComponent<Props> = (data) => {
  switch (data?._type) {
    case 'campaign':
      return <CampainPlugElementDetails data={data} />;
    default:
      return null;
  }
};

const getString = (): string => '';

export { getDetailContent, getString };
